export default function ErrorMessage({ children }: { children: React.ReactNode }) {
    if (!children) {
        return null
    }
    return <div className="mt-2 col-span-full text-small text-red-500 text-center">{children}</div>
}
